import { WMLogger } from '@mobilize/logging';
import { Inject } from '../../Application';
import { Constants, Events } from '../../Contract/Application';
var ErrorCodes = (function () {
    function ErrorCodes() {
    }
    ErrorCodes.Winforms = '01';
    ErrorCodes.BaseComponents = '02';
    ErrorCodes.AngularClient = '03';
    ErrorCodes.ClientCore = '04';
    return ErrorCodes;
}());
export { ErrorCodes };
export function MessageFormat(error, moduleCode, target, method) {
    switch (error.name) {
        case 'TypeError':
            return "[".concat(moduleCode, "10]: ").concat(target, ".").concat(method);
        case 'ReferenceError':
            return "[".concat(moduleCode, "20]: ").concat(target, ".").concat(method);
        default:
            return "[".concat(moduleCode, "30]: ").concat(target, ".").concat(method);
    }
}
export function ExceptionHandler(onException) {
    return function (target, propertyKey, descriptor) {
        var originalMethod = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var event = Inject.Instance.resolve(Constants.EventAggregator);
            try {
                return originalMethod.apply(this, args);
            }
            catch (e) {
                WMLogger.instance().error(e);
                e.message = MessageFormat(e, onException, target.constructor.name, propertyKey);
                event.publish(Events.Error, e);
                if (this[onException]) {
                    this[onException]();
                }
            }
        };
        return descriptor;
    };
}
export function ExceptionHandlerClass(moduleCode) {
    return function (target) {
        var _loop_1 = function (propertyName) {
            var descriptor = Object.getOwnPropertyDescriptor(target.prototype, propertyName);
            var isMethod = descriptor.value instanceof Function;
            if (!isMethod) {
                return "continue";
            }
            var originalMethod = descriptor.value;
            descriptor.value = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var event = Inject.Instance.resolve(Constants.EventAggregator);
                try {
                    return originalMethod.apply(this, args);
                }
                catch (e) {
                    WMLogger.instance().error(e);
                    e.message = MessageFormat(e, moduleCode, target.name, propertyName);
                    event.publish(Events.Error, e);
                }
            };
            Object.defineProperty(target.prototype, propertyName, descriptor);
        };
        for (var _i = 0, _a = Object.keys(target.prototype); _i < _a.length; _i++) {
            var propertyName = _a[_i];
            _loop_1(propertyName);
        }
    };
}
